"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var extractNames = require("@CommonFrontendBackend/Utils/ExtractNames");
var isUsingTCDC = require("@CommonFrontendBackend/FeatureFlag").isUsingTCDC;
var AcceptButton = (function () {
    function AcceptButton(createUi, make, di, userIconFactory, label, editable, onChange, click, accepters, settings, isDisabled, appEvents, usingFeature, hasEditAccess) {
        var _this = this;
        var labelEditor;
        var hideMultiAccepters = make.has("hideMultiAccepters") ? make.get("hideMultiAccepters") : false;
        var rebuildIcons = false;
        var usingTCDC = isUsingTCDC(usingFeature);
        if (editable && usingTCDC) {
            var Input = di.get("Input");
            labelEditor = Input({
                className: "accept-label-input",
                size: "auto",
                value: label(),
                onChange: onChange,
            });
        }
        var icons = [];
        var createIcons = function () {
            if (accepters.number > 1) {
                for (var i = 0; i < accepters.number; i++) {
                    if (icons[i] != null && !rebuildIcons) {
                        continue;
                    }
                    if (i < (accepters.finalisedAccepters != null ? accepters.finalisedAccepters.length : undefined)) {
                        var names = extractNames(accepters.finalisedAccepters[i].name);
                        icons.push(userIconFactory.create(names, { backgroundColor: "#00A79E" }));
                    }
                    else {
                        icons.push(userIconFactory.createEmpty({ backgroundColor: "#EBF0F3" }));
                    }
                }
                if (icons.length > accepters.number) {
                    icons = icons.splice(accepters.number, icons.length - accepters.number);
                }
            }
            rebuildIcons = false;
            return icons;
        };
        var calculateLastAccepted = function (finalisedAccepters) {
            if (finalisedAccepters == null) {
                return null;
            }
            finalisedAccepters.forEach(function (accepter) { return (accepter.acceptedAt = new Date(accepter.acceptedAt)); });
            return (0, lodash_1.maxBy)(finalisedAccepters, "acceptedAt");
        };
        var buildUi = function () {
            _this.ui = createUi(require("./AcceptButton.html"), {
                label: label,
                editor: labelEditor != null ? labelEditor.ui : undefined,
                showEditor: editable && usingTCDC,
                hasEditAccess: hasEditAccess,
                editorIsActive: false,
                usingTCDC: usingTCDC,
                click: function () {
                    if (click) {
                        click(accepters, settings);
                    }
                },
                isDisabled: isDisabled,
                icons: createIcons,
                numAccepters: function () {
                    return accepters.number;
                },
                lastAccepted: calculateLastAccepted(accepters.finalisedAccepters),
                hideMultiAccepters: hideMultiAccepters,
                handleEditClick: function ($event) {
                    if (_this.ui.editorIsActive) {
                        return $event.stopPropagation();
                    }
                    else {
                        return (_this.ui.editorIsActive = true);
                    }
                },
            });
        };
        buildUi();
        appEvents.on("accepted", function () {
            rebuildIcons = true;
            buildUi();
        });
    }
    return AcceptButton;
}());
exports.default = AcceptButton;
